// [ai] One row list for list · recent · search · journal · the timeline's day items: emoji, title, a sub line, opened through the host.
import { useAtlas } from "../../sdk/react";
import { openVia } from "./hooks";
export type Row = { key: string; href: string | null; title: string; sub?: string; emoji?: string; onOpen?: () => void };
export function Rows({ rows, empty = "Nothing here yet." }: { rows: Row[]; empty?: string }) {
  const host = useAtlas();
  if (!rows.length) return <p className="at-cat-empty">{empty}</p>;
  return (
    <ul className="at-cat-rows">
      {rows.map(r => {
        const inner = <>{r.emoji ? <span className="at-cat-e">{r.emoji}</span> : null}<span className="at-cat-t">{r.title}</span>{r.sub ? <span className="at-cat-sub">{r.sub}</span> : null}</>;
        return <li key={r.key}>{r.onOpen ? <button type="button" className="at-cat-row" data-href={r.href ?? undefined} onClick={r.onOpen}>{inner}</button> : r.href ? <a className="at-cat-row" href={r.href} onClick={openVia(host, r.href)}>{inner}</a> : <span className="at-cat-row">{inner}</span>}</li>;
      })}
    </ul>
  );
}
